// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Imergey — boxless toast notifications
   No card, no background, no border. Just an animated icon and
   text, floating briefly top-center, with a thin draining
   rule underneath as the only timing cue.
   ============================================================ */

:root {
  --ime-toast-ink: #110b2a;
  --ime-toast-success: #0f9d63;
  --ime-toast-error: #e0344c;
  --ime-toast-warning: #c9790a;
  --ime-toast-info: #2566c8;
  --ime-toast-default: #45495c;
}

.Toastify__toast-container--top-center {
  width: auto;
  max-width: 92vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 0;
  top: 1.5em;
}

.Toastify__toast {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: auto;
  max-width: 460px;
  margin: 0;
  padding: 0;
  min-height: 0;
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 0;
  overflow: visible;
  cursor: default;
  font-family: inherit;
}

.Toastify__toast-body {
  padding: 0;
  margin: 0;
  align-items: stretch;
  width: 100%;
}

.ime-toast-wrap {
  display: flex;
  flex-direction: column;
  gap: 7px;
  width: 100%;
  animation: ime-toast-reveal 0.4s ease both;
}

@keyframes ime-toast-reveal {
  from {
    opacity: 0;
    filter: blur(6px);
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    filter: blur(0);
    transform: translateY(0);
  }
}

.ime-toast-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ime-toast-icon {
  flex-shrink: 0;
  width: 19px;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ime-toast-accent, var(--ime-toast-default));
  filter: drop-shadow(0 1px 8px var(--ime-toast-accent-soft, transparent));
}

.ime-toast-icon svg {
  width: 100%;
  height: 100%;
  overflow: visible;
}

.ime-toast-icon-path {
  stroke-dasharray: 44;
  stroke-dashoffset: 44;
  animation: ime-toast-draw 0.45s cubic-bezier(0.65, 0, 0.35, 1) forwards;
  animation-delay: 0.05s;
}

.ime-toast-message {
  font-size: 14.5px;
  font-weight: 600;
  letter-spacing: -0.1px;
  line-height: 1.35;
  color: var(--ime-toast-ink);
  text-shadow:
    0 0 1px rgba(255, 255, 255, 0.9),
    0 1px 14px rgba(255, 255, 255, 0.85),
    0 1px 2px rgba(255, 255, 255, 0.9);
  /* Was single-line "white-space: nowrap" + ellipsis — fine for a short
     "Saved successfully", but a longer server error (e.g. "This Brand user
     cannot be deleted until all assigned customers are reassigned.") got
     silently cut off mid-sentence with no way to read the rest, since this
     toast has no expand/hover-to-reveal affordance. Wraps onto a second
     line instead of truncating; max-width raised to match so it doesn't
     wrap too eagerly on an ordinary short message. */
  white-space: normal;
  overflow-wrap: break-word;
  max-width: 380px;
}

.ime-toast-rule {
  height: 1px;
  width: 100%;
  background: rgba(17, 11, 42, 0.12);
  border-radius: 1px;
  overflow: hidden;
  margin-left: 29px;
}

.ime-toast-rule-fill {
  display: block;
  height: 100%;
  width: 100%;
  background: var(--ime-toast-accent, var(--ime-toast-default));
  transform: scaleX(1);
  transform-origin: left;
  animation-name: ime-toast-drain;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}

.Toastify__toast:hover .ime-toast-rule-fill {
  animation-play-state: paused;
}

.Toastify__toast--success {
  --ime-toast-accent: var(--ime-toast-success);
  --ime-toast-accent-soft: rgba(15, 157, 99, 0.45);
}
.Toastify__toast--error {
  --ime-toast-accent: var(--ime-toast-error);
  --ime-toast-accent-soft: rgba(224, 52, 76, 0.45);
}
.Toastify__toast--warning {
  --ime-toast-accent: var(--ime-toast-warning);
  --ime-toast-accent-soft: rgba(201, 121, 10, 0.45);
}
.Toastify__toast--info {
  --ime-toast-accent: var(--ime-toast-info);
  --ime-toast-accent-soft: rgba(37, 102, 200, 0.45);
}

/* Deliberately not overriding visibility here: react-toastify's
   auto-close timer fires off this element's own CSS animation
   ending, so it must stay rendered. hideProgressBar already hides
   it via opacity:0 (set inline by the library), which keeps the
   animation — and therefore auto-dismiss — working. */

.ime-toast-close {
  position: relative;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-left: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ime-toast-ink);
  opacity: 0;
  transition: opacity 0.2s ease, transform 0.3s ease;
}

.Toastify__toast:hover .ime-toast-close {
  opacity: 0.55;
}

.ime-toast-close:hover {
  opacity: 1 !important;
  transform: rotate(90deg);
}

.ime-toast-close svg {
  width: 12px;
  height: 12px;
  filter: drop-shadow(0 1px 4px rgba(255, 255, 255, 0.9));
}

@keyframes ime-toast-draw {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes ime-toast-drain {
  to {
    transform: scaleX(0);
  }
}

@media (max-width: 480px) {
  .Toastify__toast-container--top-center {
    width: 100%;
    max-width: 100%;
    padding: 0 24px;
  }
  .ime-toast-message {
    max-width: 64vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/toast.css"],"names":[],"mappings":"AAAA;;;;;iEAKiE;;AAEjE;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,kCAAkC;EAClC,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,eAAe;IACf,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wDAAwD;EACxD,wEAAwE;AAC1E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,uEAAuE;EACvE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;EAC3B;;;sCAGoC;EACpC;;;;;;qDAMmD;EACnD,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,6DAA6D;EAC7D,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;EAC/B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,gDAAgD;AAClD;AACA;EACE,0CAA0C;EAC1C,gDAAgD;AAClD;AACA;EACE,4CAA4C;EAC5C,iDAAiD;AACnD;AACA;EACE,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;;;;sDAIsD;;AAEtD;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ============================================================\n   Imergey — boxless toast notifications\n   No card, no background, no border. Just an animated icon and\n   text, floating briefly top-center, with a thin draining\n   rule underneath as the only timing cue.\n   ============================================================ */\n\n:root {\n  --ime-toast-ink: #110b2a;\n  --ime-toast-success: #0f9d63;\n  --ime-toast-error: #e0344c;\n  --ime-toast-warning: #c9790a;\n  --ime-toast-info: #2566c8;\n  --ime-toast-default: #45495c;\n}\n\n.Toastify__toast-container--top-center {\n  width: auto;\n  max-width: 92vw;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 18px;\n  padding: 0;\n  top: 1.5em;\n}\n\n.Toastify__toast {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  width: auto;\n  max-width: 460px;\n  margin: 0;\n  padding: 0;\n  min-height: 0;\n  background: transparent !important;\n  box-shadow: none !important;\n  border-radius: 0;\n  overflow: visible;\n  cursor: default;\n  font-family: inherit;\n}\n\n.Toastify__toast-body {\n  padding: 0;\n  margin: 0;\n  align-items: stretch;\n  width: 100%;\n}\n\n.ime-toast-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  width: 100%;\n  animation: ime-toast-reveal 0.4s ease both;\n}\n\n@keyframes ime-toast-reveal {\n  from {\n    opacity: 0;\n    filter: blur(6px);\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    filter: blur(0);\n    transform: translateY(0);\n  }\n}\n\n.ime-toast-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ime-toast-icon {\n  flex-shrink: 0;\n  width: 19px;\n  height: 19px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--ime-toast-accent, var(--ime-toast-default));\n  filter: drop-shadow(0 1px 8px var(--ime-toast-accent-soft, transparent));\n}\n\n.ime-toast-icon svg {\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n}\n\n.ime-toast-icon-path {\n  stroke-dasharray: 44;\n  stroke-dashoffset: 44;\n  animation: ime-toast-draw 0.45s cubic-bezier(0.65, 0, 0.35, 1) forwards;\n  animation-delay: 0.05s;\n}\n\n.ime-toast-message {\n  font-size: 14.5px;\n  font-weight: 600;\n  letter-spacing: -0.1px;\n  line-height: 1.35;\n  color: var(--ime-toast-ink);\n  text-shadow:\n    0 0 1px rgba(255, 255, 255, 0.9),\n    0 1px 14px rgba(255, 255, 255, 0.85),\n    0 1px 2px rgba(255, 255, 255, 0.9);\n  /* Was single-line \"white-space: nowrap\" + ellipsis — fine for a short\n     \"Saved successfully\", but a longer server error (e.g. \"This Brand user\n     cannot be deleted until all assigned customers are reassigned.\") got\n     silently cut off mid-sentence with no way to read the rest, since this\n     toast has no expand/hover-to-reveal affordance. Wraps onto a second\n     line instead of truncating; max-width raised to match so it doesn't\n     wrap too eagerly on an ordinary short message. */\n  white-space: normal;\n  overflow-wrap: break-word;\n  max-width: 380px;\n}\n\n.ime-toast-rule {\n  height: 1px;\n  width: 100%;\n  background: rgba(17, 11, 42, 0.12);\n  border-radius: 1px;\n  overflow: hidden;\n  margin-left: 29px;\n}\n\n.ime-toast-rule-fill {\n  display: block;\n  height: 100%;\n  width: 100%;\n  background: var(--ime-toast-accent, var(--ime-toast-default));\n  transform: scaleX(1);\n  transform-origin: left;\n  animation-name: ime-toast-drain;\n  animation-timing-function: linear;\n  animation-fill-mode: forwards;\n}\n\n.Toastify__toast:hover .ime-toast-rule-fill {\n  animation-play-state: paused;\n}\n\n.Toastify__toast--success {\n  --ime-toast-accent: var(--ime-toast-success);\n  --ime-toast-accent-soft: rgba(15, 157, 99, 0.45);\n}\n.Toastify__toast--error {\n  --ime-toast-accent: var(--ime-toast-error);\n  --ime-toast-accent-soft: rgba(224, 52, 76, 0.45);\n}\n.Toastify__toast--warning {\n  --ime-toast-accent: var(--ime-toast-warning);\n  --ime-toast-accent-soft: rgba(201, 121, 10, 0.45);\n}\n.Toastify__toast--info {\n  --ime-toast-accent: var(--ime-toast-info);\n  --ime-toast-accent-soft: rgba(37, 102, 200, 0.45);\n}\n\n/* Deliberately not overriding visibility here: react-toastify's\n   auto-close timer fires off this element's own CSS animation\n   ending, so it must stay rendered. hideProgressBar already hides\n   it via opacity:0 (set inline by the library), which keeps the\n   animation — and therefore auto-dismiss — working. */\n\n.ime-toast-close {\n  position: relative;\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  margin-left: 10px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--ime-toast-ink);\n  opacity: 0;\n  transition: opacity 0.2s ease, transform 0.3s ease;\n}\n\n.Toastify__toast:hover .ime-toast-close {\n  opacity: 0.55;\n}\n\n.ime-toast-close:hover {\n  opacity: 1 !important;\n  transform: rotate(90deg);\n}\n\n.ime-toast-close svg {\n  width: 12px;\n  height: 12px;\n  filter: drop-shadow(0 1px 4px rgba(255, 255, 255, 0.9));\n}\n\n@keyframes ime-toast-draw {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n@keyframes ime-toast-drain {\n  to {\n    transform: scaleX(0);\n  }\n}\n\n@media (max-width: 480px) {\n  .Toastify__toast-container--top-center {\n    width: 100%;\n    max-width: 100%;\n    padding: 0 24px;\n  }\n  .ime-toast-message {\n    max-width: 64vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
